import {
  EventsActionNames,
  type LoadEventsInfoFailed,
  type LoadEventsInfoRequest,
  type LoadEventsInfoSucceeded,
} from './actions';

import type { Events, TimestampInMillis } from '@cobliteam/common-types';

export const loadEventsInfoSucceeded = (
  eventsInfo: Events[]
): LoadEventsInfoSucceeded => ({
  type: EventsActionNames.LOAD_EVENTS_INFO_SUCCEEDED,
  payload: eventsInfo,
});

export const loadEventsInfoRequest = (
  startDate: TimestampInMillis,
  endDate: TimestampInMillis
): LoadEventsInfoRequest => ({
  type: EventsActionNames.LOAD_EVENTS_INFO_REQUEST,
  payload: {
    startDate,
    endDate,
  },
});

export const loadEventsInfoFailed = (): LoadEventsInfoFailed => ({
  type: EventsActionNames.LOAD_EVENTS_INFO_FAILED,
});
